import type { NewConfirmationFormData } from "../../confirmations/types/new-confirmation.types";

export function getDefaultPaymentFormData(): NewConfirmationFormData {
  const today = new Date();
  const fecha =
    today.getFullYear() +
    "-" +
    String(today.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(today.getDate()).padStart(2, "0");
  return {
    cliente: "",
    clienteId: null,
    pagadorEsMismoCliente: false,
    nombrePagador: "",
    pagadorId: null,
    monto: "",
    tipoMoneda: "COP",
    banco: "",
    fecha,
    nota: "",
    comprobante: null,
  };
}
